<template lang="html">
  <div class="file">
    <div class="percent">
      <div class="percent-icon" v-show="!checked">
        <el-progress
        v-if = "percent !== 100"
        type="circle"
        :show-text = "false"
        :width="18" :percentage="percent" :stroke-width="3">
        </el-progress>
        <i class="el-icon-circle-check"
          style="font-size:17px;color:#43d480"
          v-if="percent === 100">
        </i>
      </div>
      <el-checkbox v-if="fileState ===''&&isDelete===''" v-model="checked" @change="changeChecked"></el-checkbox>
    </div>
    <div class="name">
      {{ name }}
    </div>
    <!-- <el-popover
      ref="popovera"
      placement="top"
      width="160"
      :disabled="dis.file"
      v-model="visible"
      title="下载包裹">
      <div class="po-name">{{name}}</div>
      <p></p>
      <div style="text-align: right; margin: 0">
        <el-button size="mini" type="text" @click="visible = false">取消</el-button>
        <el-button type="primary" size="mini" @click="download (id, fileState)">确定</el-button>
      </div>
    </el-popover>
    <div class="download appDownload" :class="appActive" @click="appDownloadFile" v-if="fileState ==='download'&&isDelete===''">
      <span class="icon download" v-popover:popovera title="下载文件">
        &#xe820;
      </span>
    </div> -->
    <div class="size">
      {{ size }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      app: 'app'
    })
  },
  props: {
    id: String,
    percent: Number,
    name: String,
    size: String,
    fileState: String,
    checkedList: Array,
    isDelete: String,
  },
  watch: {
    checkedList: function () {
      if (this.checkedList.length === 0) {
        this.checked = false
      } else {
        for (var i = 0; i < this.checkedList.length; i++) {
          if (this.checkedList[i].id === this.id) {
            this.checked = true
            return
          } else {
            this.checked = false
          }
        }
      }
    },
    'app.login': function (val) {
      if (val) {
        this.appActive = 'active'
      } else {
        this.appActive = ''
        this.dis.file = true
      }
    }
  },
  data () {
    return {
      appActive: '',
      dis: {
        file: true
      },
      visible: false,
      checked: false
    }
  },
  mounted () {
    for (var i = 0; i < this.checkedList.length; i++) {
      if (this.checkedList[i].id === this.id) {
        this.checked = true
        return
      } else {
        this.checked = false
      }
    }
    if (this.app.login) {
      this.appActive = 'active'
    } else {
      this.appActive = ''
      this.dis.file = true
    }
  },
  methods: {
    appDownloadFile () {
      if (this.app.login) {
        this.dis.file = false
      } else {
        this.$app.login(0, response => {
          if (response === 2) {
            this.$app.start()
          }
        })
      }
    },
    download (id, fileState) {
      this.visible = false
      var start = {
        'taskType': fileState,
        'start': 1,
        'fileIds': [id]
      }
      this.$app.newTask(start, response => {
        if (response.error === 0) {
          this.$message({
            message: '该文件下载任务创建成功，进入下载队列',
            type: 'success',
            duration: 4000
          })
          setTimeout(() => {
            this.$store.dispatch('showTransfer', {
              show: true,
              type: 'download'
            })
          }, 1200)
        } else {
          if (response.error === 4) {
            this.$message({
              message: '该文件已经在下载队列中',
              type: 'warning'
            })
          }
        }
      })
    },
    changeChecked () {
      if (this.checked) {
        var checked = true
      } else {
        checked = false
      }
      var msg = {
        id: this.id,
        name: this.name,
        checked: checked
      }
      this.$emit('cellChecked', msg)
    }
  }
}
</script>

<style lang="css" scoped>
.file {
  position: relative;
  width: 100%;
  height: 34px;
  line-height: 34px;
  padding: 0 18px;
}
.file:hover {
  background-color: #ddf0fb;
}
/* .file:hover .percent-icon {
  display: none;
} */
.percent {
  position: relative;
  float: left;
  display: block;
  margin-top: 8px;
  width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  overflow: hidden;
}
.percent .percent-icon {
  position: absolute;
  z-index: 2;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  /*background-color: #fff;*/
}
/* .percent:hover .percent-icon {
  display: none;
} */
.percent .el-checkbox {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
}
.name {
  position: absolute;
  left: 50px;
  font-size: 14px;
  top: 0px;
  right: 380px;
  text-align: left;
  border-bottom: 0px;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.size {
  font-size: 14px;
  width: 120px;
  float: right;
  margin-right: 40px;
}
.download {
  display: none;
  cursor: pointer;
  float: right;
  width: 80px;
  margin: 0 10px;
}
.file:hover .download {
  display: block;
}
.po-name {
  width: 100%;
  font-size: 14px;
  padding-left: 2px;
  color: #0291cf;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.appDownload {
  opacity: 0.4;
}
.appDownload.active {
  opacity: 1;
}
</style>
